module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-textarea/spk-textarea.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-textarea/spk-textarea.component.scss
// module chunks = main